window.Products.Material.Fabric = function() {
};
window.Products.Material.Fabric.inherits(window.Products.Material.Material);
window.Products.Material.Fabric.id = 50;
window.Products.Material.Fabric.slug = 'fabric';